<template>
  <v-container full-height>
    <v-row>
      <v-col cols="12">
        <card-list v-model="items" #default="{ item }">
          <v-row>
            <v-col cols="1">
                <expandable-image
                    :src="`${item.img}`"
                    :close-on-background-click="true"
                />
            </v-col>
            <v-col cols="3">
              <!-- <span class="title">{{item.nome}}</span> <br/> -->
              <!-- <span class="body-2">{{item.descricao}}</span> <br/> -->

              <v-text-field v-model="item.nome" label="Nome" hint="Insira o Nome do Produto"  />
            </v-col>
            <v-col cols="4">
              <!-- <span class="subtitle-1"><b>Tamanho:</b> {{item.tamanho}}</span> <br/>          -->
              <!-- <span class="caption">R$ {{item.preco}}</span> -->
                <v-tooltip top>
                    <template v-slot:activator="{ on }">                    
                        <v-textarea v-on="on" v-model="item.descricao" label="Descrição" rows="1" :auto-grow="false" hint="Insira uma Descrição para o Produto"/>
                    </template>
                    <span>{{item.descricao}}</span>
                </v-tooltip>                         
            </v-col>          
            <v-col cols="2">
                <v-text-field v-model="item.preco" label="Valor" value="10.00" prefix="R$" type="number" hint="Insira o valor do produto (#,##)" step="0.01"></v-text-field>
            </v-col>   
            <v-col cols="2">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">                  
                        <v-switch v-on="on" flat v-model="item.ativo" :label="(item.ativo) ? 'Disponível' : 'Indisponível'"></v-switch>
                    </template>
                    <span>Selecione se o produto estiver disponível.</span>
                </v-tooltip>                           
            </v-col>                   
          </v-row>
        </card-list>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="auto" class="py-0 mx-auto">
        <CreateProd :selCatId="selCategory.id" :selCat="selCategory.nome" v-on:productAdded="loadProducts"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CardList from './cardList'
import CreateProd from './createProducts'
import {files} from "@/main"

export default {
  components: {
    CardList,
    CreateProd
  },
  props:['categoryId'],
  data: () => ({
    items: [
      {
        id: 1,
        name: 'Heineken 330ml',
        descricao: 'Cerveja Longneck Lata 330ml',
        img: 'cervejas/beer1.jpeg',
        disponivel: true
      },
      {
        id: 2,
        name: 'Eisenbahn 350ml',
        descricao: 'Cerveja Eisenbahn Longneck 350ml',
        img: 'cervejas/beer2.jpeg',
        disponivel: false
      },
      {
        id: 3,
        name: 'Amstel Lata 350ml',
        descricao: 'Cerveja Pilsen Puro Malte Amstel Lata 350ml',
        img: 'cervejas/beer3.jpeg',
        disponivel: true
      }
    ],
    counter: 10,  
    maior: true,
    publicPath: process.env.BASE_URL,
    open: false,
    selCategory: null

  }),
  created(){
    console.log("Created", this.$route.params)
    // this.loadProducts()
  }, 
  beforeRouteUpdate(to, from, next) {
    next()   
    // this.loadProducts()
  },   
  methods: {
    add () {
      this.items.push({ id: this.counter++ })
    },  
    async loadProducts(){
        let categoryId = this.$route.params.categoryId;    
        let products = this.$store.getters.data.data.produtos
        let ref = files.ref();

        this.items = []
        this.items.push(products.filter((prod) => {
            return prod.categoria.id.match(categoryId)            
        }))    

        this.items = this.items[0]
        let each = []
        this.items.forEach(async (item,idx) => {
          console.log("item",item,ref)
            let change = item
            change.idx = item.id
            change.id = idx
            if (typeof item.imagens != 'undefined'){
              await ref.child(item.imagens[0]).getDownloadURL().then(function(url){
                change.img = url
              })              
            } else {
              change.img = this.publicPath+'semfoto.gif'
            }
            each.push(change)
        })
        this.items = each

        this.selCategory = this.$store.getters.data.data.categorias.filter((cat) => {
                              return cat.id.match(categoryId)
                            })[0]
        // console.log("teste", this.$store.getters.data.data.categorias, this.selCategory) 
    }
  }
}
// <style scoped>
// .container {
//   max-width: 600px !important;
// }
// </style>
</script>

